import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BodyClassName from 'react-body-classname';
import CSSTransition from 'react-transition-group/CSSTransition';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import { CoreModal } from 'components/core/library/modalV2';
import ModalClose from './ModalClose';

import './modal.scss';

export default function Modal(props) {
	return (
		<BodyClassName className={classnames({ 'no-scroll': props.showing })}>
			<TransitionGroup>
				{!!props.showing &&
					<CSSTransition
						classNames="transition-fade-in"
						timeout={150}
					>
						<CoreModal {...props} />
					</CSSTransition>
				}
			</TransitionGroup>
		</BodyClassName>
	);
}

Modal.propTypes = {
	/** If the modal should be showing */
	showing: PropTypes.bool,
	/** If the modal should have a close button */
	closeable: PropTypes.bool,
	/** The component to use in the corner as the close button */
	closeComponent: PropTypes.func,
	/** Function to handle onClose events and manage the closed/open state */
	onClose: PropTypes.func,
	/** Size of the modal: 'small', 'medium', 'large', or 'fullscreen' */
	size: PropTypes.oneOf(['small', 'medium', 'large', 'wide','fullscreen']),
	/** Text for close button instead of X icon */
	closeButtonText: PropTypes.string
};

Modal.defaultProps = {
	closeComponent: ModalClose
};
